import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _46fa64b6 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _67a15b5d = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _e3467500 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _6030549e = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _7f8d913e = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _f5000b10 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _20515136 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _d8f456de = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _b5a8ff4c = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _1d44edfb = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _f2091ae2 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _5cab45e1 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _736bcce7 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _3e011f3e = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _e5c23994 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _194955a1 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _4339b848 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _d8601304 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _37597bc6 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _34d2dd06 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _5dfbe528 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _38d9c4b4 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _3212ae68 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _807741f6 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _18067a8b = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _1474210c = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _f78fef88 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _d5e02af4 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _33482e64 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _4b147104 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _37a5318a = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _66bab71c = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _867430d2 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _510550cf = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _3e270a5e = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _c4ab1f1a = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _264bd664 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _6b0abd20 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _494d8c4e = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _2b755c3c = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _7efb63e2 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _954fd824 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _1b6d21de = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _5cf7f188 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _5734e63f = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _2bd8898b = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _79c2b735 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _44e289cf = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _1ee404d2 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _3763b9bd = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _c88bd5f8 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _b1774668 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _11806a93 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _a8fb0df6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _230f1638 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _299b491d = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _8a8671b4 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _6abae8f9 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _d2c6bfe8 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _5388aab7 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _06fb44ca = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _0afa5324 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _3306e3bf = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _23ff3af7 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _ac3a1a94 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _157c1566 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _3d5e27e8 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _ca68ffcc = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _6f2acb26 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _4a71d142 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _3092ccb7 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _b6f5e352 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _49ad6f2a = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _8d3e39ce = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _a47fd802 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _8f3966ee = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _46fa64b6,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _67a15b5d,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _e3467500,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _6030549e,
    name: "calendar"
  }, {
    path: "/customer",
    component: _7f8d913e,
    name: "customer"
  }, {
    path: "/details",
    component: _f5000b10,
    name: "details"
  }, {
    path: "/goals",
    component: _20515136,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _d8f456de,
    name: "maisoku"
  }, {
    path: "/media",
    component: _b5a8ff4c,
    name: "media"
  }, {
    path: "/privacy",
    component: _1d44edfb,
    name: "privacy"
  }, {
    path: "/project",
    component: _f2091ae2,
    name: "project"
  }, {
    path: "/response",
    component: _5cab45e1,
    name: "response"
  }, {
    path: "/sale",
    component: _736bcce7,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _3e011f3e,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _e5c23994,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _194955a1,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _4339b848,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _d8601304,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _37597bc6,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _34d2dd06,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _5dfbe528,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _38d9c4b4,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _3212ae68,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _807741f6,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _18067a8b,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _1474210c,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _f78fef88,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _d5e02af4,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _33482e64,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _4b147104,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _37a5318a,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _66bab71c,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _867430d2,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _510550cf,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _3e270a5e,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _c4ab1f1a,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _264bd664,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _6b0abd20,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _494d8c4e,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _2b755c3c,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _7efb63e2,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _954fd824,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _1b6d21de,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _5cf7f188,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _5734e63f,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _2bd8898b,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _79c2b735,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _44e289cf,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _1ee404d2,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _3763b9bd,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _c88bd5f8,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _b1774668,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _11806a93,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _a8fb0df6,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _230f1638,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _299b491d,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _8a8671b4,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _6abae8f9,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _d2c6bfe8,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _5388aab7,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _06fb44ca,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _0afa5324,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _3306e3bf,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _23ff3af7,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _ac3a1a94,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _157c1566,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _3d5e27e8,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _ca68ffcc,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _6f2acb26,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _4a71d142,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _3092ccb7,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _b6f5e352,
    name: "property-property",
    children: [{
      path: "contact",
      component: _49ad6f2a,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _8d3e39ce,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _a47fd802,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _8f3966ee,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
